(function () {
  function getCurrentTheme() {
    return document.documentElement.getAttribute('data-theme') || 'light';
  }
 
  function syncToggleButtons(theme) {
    var isDark = theme === 'dark';
    document.querySelectorAll('[data-theme-toggle]').forEach(function (button) {
      button.setAttribute('aria-pressed', String(isDark));
      button.setAttribute('aria-label', isDark ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro');
    });
  }
 
  function applyTheme(theme) {
    document.documentElement.setAttribute('data-theme', theme);
    syncToggleButtons(theme);
  }
 
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-theme-toggle]');
    if (!toggle) return;
 
    var newTheme = getCurrentTheme() === 'dark' ? 'light' : 'dark';
    localStorage.setItem('bimo:theme', newTheme);
    applyTheme(newTheme);
  });
 
  // Sincroniza el estado visual de los botones con el tema ya aplicado
  // tempranamente en el <head> (evita parpadeo al cargar).
  syncToggleButtons(getCurrentTheme());
})();
 